import {
  SidebarMenuControlCapability,
  type Specs,
} from '@doxyme/extensions-bridge';
import {
  useAddCapability,
  useBasicObservable,
} from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type Control = Specs.Control.Control;

// todo: (CS-17504 potentially) move this type to the UI component
export type SidebarMenuControl = {
  id: string;
  label: string;
  icon: string;
  onClick: () => void;
};

type UseExtensionsSidebarMenuControlReturnType = SidebarMenuControl[];

/**
 * Hook responsible for providing ability to render sidebar extension controls to the Extensions SDK
 */
export function useExtensionsSidebarMenuControl(): UseExtensionsSidebarMenuControlReturnType {
  const sidebarMenuControl = useAddCapability(
    bridge,
    () => new SidebarMenuControlCapability(),
  );

  const [controls] = useBasicObservable<Control[]>(sidebarMenuControl.controls);

  return controls as SidebarMenuControl[];
}
